import { createBehavior } from '@area17/a17-behaviors';

const sharescrolled = createBehavior(
  'sharescrolled',
  {
    measure() {
      const topRect = this.$topSensor.getBoundingClientRect();
      const bottomRect = this.$bottomSensor.getBoundingClientRect();
      this.isVisiblePrev = this.isVisible;
      this.isVisible = topRect.y < 0 && bottomRect.y > window.innerHeight;
      this.render();
    },
    onIntersectionChange() {
      this.measure();
    },
    render() {
      if (this.isVisible !== this.isVisiblePrev) {
        this.$node.classList.toggle('sharescrolled:is-visible', this.isVisible);
      }
    },
  },
  {
    init() {
      this.$topSensor = this.getChild('top-sensor');
      this.$bottomSensor = this.getChild('bottom-sensor');
      this.$share = this.getChild('share');
      this.isVisible = false;

      const observer = new IntersectionObserver(this.onIntersectionChange, {
        root: null,
        rootMargin: '0px',
        threshold: 1,
      });

      this.observer = observer;

      if (this.$topSensor) {
        this.observer.observe(this.$topSensor);
      }

      if (this.$bottomSensor) {
        this.observer.observe(this.$bottomSensor);
      }
    },
    destroy() {
      if (this.$topSensor) {
        this.observer.unobserve(this.$topSensor);
      }

      if (this.$bottomSensor) {
        this.observer.unobserve(this.$bottomSensor);
      }
    },
  }
);

export default sharescrolled;
